import { Component, inject, OnDestroy, OnInit, ChangeDetectionStrategy } from '@angular/core'
import { MAT_DIALOG_DATA, MatDialogModule, MatDialogRef } from '@angular/material/dialog'
import { Subject, takeUntil } from 'rxjs'
import { MatButtonModule } from '@angular/material/button'
import { MatIconModule } from '@angular/material/icon'
import { escapeKey$ } from '../../services'
import { TranslatePipe } from '@ngx-translate/core'

export interface MessageDialogData {
  title: string
  plainTextMessage: string
  htmlMessage: string
  logos?: MessageDialogLogo[]
}

export interface MessageDialogLogo {
  src: string
  url: string
}

@Component({
  selector: 'app-message-dialog',
  templateUrl: './message-dialog.component.html',
  styleUrls: ['./message-dialog.component.scss'],
  changeDetection: ChangeDetectionStrategy.Eager,
  imports: [TranslatePipe, MatDialogModule, MatButtonModule, MatIconModule],
})
export class MessageDialogComponent implements OnInit, OnDestroy {
  private readonly dialogRef = inject<MatDialogRef<MessageDialogComponent>>(MatDialogRef)
  data = inject<MessageDialogData>(MAT_DIALOG_DATA)

  private readonly unsubscribe$ = new Subject<void>()

  constructor() {
    escapeKey$(this.dialogRef).subscribe(() => this.dialogRef.close())
  }

  ngOnInit(): void {
    this.dialogRef
      .keydownEvents()
      .pipe(takeUntil(this.unsubscribe$))
      .subscribe((event) => {
        console.log('keydownEvents', event.key)
        if (event.key === 'Enter') {
          this.ok()
          event.preventDefault()
        }
      })
  }

  ok() {
    // console.log('cancel')
    this.dialogRef.close(false)
  }

  openInNewTab(url: string) {
    window.open(url, '_blank')
  }

  ngOnDestroy(): void {
    this.unsubscribe$.next()
  }
}
